module.exports = __webpack_public_path__ + "5cb71c987ed2c8eaf71f8f81dfbf6899.png";